import Vue from 'vue';
import Router from 'vue-router';
import DashboardLayout from '@/layout/DashboardLayout';
import AuthLayout from '@/layout/AuthLayout';

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/home',
      redirect: 'menu',
      component: DashboardLayout,
      children: [
        {
          path: '/menu',
          name: 'Accueil',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Home.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/addProduct/:id',
          name: 'addproduct',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Produit/AddProduct.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Dashboard.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/caisse/:id',
          name: 'caisse',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Tables/DeliveryTable.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/sp',
          name: 'sp',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/SPTables.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/historique',
          name: 'historique',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Historique.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/retours',
          name: 'retours',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Returns.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/payments',
          name: 'payments',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Payments.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/categorie',
          name: 'liste des categories',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/ListeCategorie.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/listeproduitArchive/:id?',
          name: 'Archived Products',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/ListeProduitArchived.vue'),
          roles: ['admin']
        },
        {
          path: '/listeproduit/:id?',
          name: 'products',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/ListeProduit.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/permissions/:id',
          name: 'permissions',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Permissions.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/maps',
          name: 'maps',
          /// component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Maps.vue')
        },
        {
          path: '/tablesuser',
          name: 'liste des utilisateurs',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/TablesUser.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/appsettings',
          name: 'Paramètre du plateforme',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Settings.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/caissehistory',
          name: 'Historiquedecaisse',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/TablesCaisse.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Profile.vue'),
          roles: ['admin', 'supervisor']
        },
        {
          path: '/tablesclient',
          name: 'clients',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/TablesClient.vue'),
          roles: ['admin', 'supervisor']
        }
      ]
    },
    {
      path: '/login',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Login.vue')
        },
        {
          path: '/register',
          name: 'register',
          // component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Register.vue')
        }
      ]
    },
    {
      path: '/myspace/:id',
      name: 'myspace',
      component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/MySpace.vue')
    },
    {
      path: "*",
      redirect: 'dashboard',
      component: DashboardLayout
    }
  ]
});

router.beforeEach((to, from, next) => {
  let isAuthenticated = localStorage.getItem("accessToken") ? true : false;
  let user = JSON.parse(localStorage.getItem("user"));

  // List of admin-only routes
  const adminRoutes = [
    'Articles Archive',
    // add other admin-only route names here
  ];

  if (to.name !== 'login' && !isAuthenticated && to.name !== "myspace") next({ name: 'login' });
  if (to.name === 'login' && isAuthenticated) next({ name: 'Accueil' });
  else if (adminRoutes.includes(to.name) && (!user || user.role !== 'admin')) {
    next({ name: 'Accueil' }); 
  } else next();
});

export default router;
